import {Component, Inject, OnInit} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {finalize, take} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SafeStringType} from '../../../types/safe-string-type.enum';
import {SafePipe} from '../../../../common/pipes/safe.pipe';
import {SharedService} from '../../../../common/services/shared-service';
import {ReportingService} from '../../../../other/services/reporting.service';

@Component({
  selector: 'app-activity-results-dialog',
  templateUrl: './activity-results-dialog.component.html',
  styleUrls: ['./activity-results-dialog.component.scss'],
  providers: [SafePipe]
})
export class ActivityResultsDialogComponent implements OnInit {
  readonly activityHTMLReportURI: string = '/Reports/Activity_Messages';
  isBusyCounter = 0;
  activityId: number;

  html: SafeHtml;
  isHtmlValid = true;

  constructor(
    private reportingService: ReportingService,
    private sharedService: SharedService,
    private safePipe: SafePipe,
    public dialogRef: MatDialogRef<ActivityResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number
  ) {
    this.activityId = data;
  }

  ngOnInit(): void {
    this.getReportHtml(this.activityHTMLReportURI, `Activity_Id=${this.activityId}`);
  }

  private getReportHtml(uri: string, parameters: string) {
    this.isBusyCounter++;
    this.reportingService.getReportHtml(uri, parameters)
      .pipe(
        take(1),
        finalize(() => this.isBusyCounter--)
      )
      .subscribe({
        next: (result: string) => {
          this.html = this.safePipe.transform(result, SafeStringType.Html);
          this.determineValidityOfHtml();
        },
        error: () => {
          this.sharedService.openErrorDialog('There was an error generating the report');
        }
      });
  }

  private determineValidityOfHtml(): void {
    const htmlString = this.html['changingThisBreaksApplicationSecurity'];
    this.isHtmlValid = htmlString.includes('Activity');
  }
}
